import axios from "axios";
import { baseUrl } from "../config/constants";
import { handleCookies } from "../utils/cookies";
const { post, get } = axios;

const getToken = () => {
  const { token } = handleCookies.fetchCookies();
  return "Bearer " + token;
};

const updateDetails = async (data) => {
  try {
    const response = await post(`${baseUrl}/updateUserDetails`, data, {
      headers: {
        Authorization: getToken(),
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error.message;
  }
};

const getUsers = async (roleId = null, offset = 0, limit = 25, includeDeactivated = false, statusFilter = 'all', search) => {
  try {
    const body = {
      offset: offset,
      limit: limit,
      include_deactivated: includeDeactivated,
      status_filter: statusFilter,
      search
    };
    if (roleId) {
      body.role_id = roleId;
    }

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/usersListing`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
        body: JSON.stringify(body),
      },
    );
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

const getUserDetails = async (id) => {
  try {
    const response = await get(
      `${process.env.REACT_APP_API_URL}/userDetails/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
        body: JSON.stringify({ id: id }),
      },
    );
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

const deleteUser = async (id) => {
  const response = await fetch(`${baseUrl}/deleteUser`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: getToken(),
    },
    body: JSON.stringify({ id: id }),
  });
  return response;
};

const getRoles = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/rolesListing`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
      },
    );
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

const updateProfileData = async (url, data) => {
  try {
    const response = await post(`${baseUrl}${url}`, data, {
      headers: {
        Authorization: getToken(),
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error.message;
  }
};

const inviteUser = async (data) => {
  try {
    const response = await post(`${baseUrl}/inviteUser`, data, {
      headers: {
        Authorization: getToken(),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error inviting user:", error);
    throw error;
  }
};

const reactivateUser = async (id) => {
  try {
    const response = await post(`${baseUrl}/reactivateUser`, { id }, {
      headers: {
        Authorization: getToken(),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error reactivating user:", error);
    throw error;
  }
};

export const handleUserDetails = {
  getUsers,
  getUserDetails,
  deleteUser,
  updateDetails,
  updateProfileData,
  getRoles,
  inviteUser,
  reactivateUser,
};
